






import { Vue, Component, Prop } from 'vue-property-decorator';
import AmapAdapter from '@/common/util/aMap';
import { bd09ToGcj02 } from '@/common/util/mapUtil';

declare var markerArr: any[];

@Component({})
export default class TopPanel extends Vue {
    amapAdapter: AmapAdapter;

    myGeo: any;
    map: any;


    center: any = undefined;

    public latitude: number = 32.181385;
    public longitude: number = 119.423057;
    mounted() {
        this.$nextTick(() => {
            this.amapAdapter = new AmapAdapter('dituContent', 119.446448, 32.164418, 5);
            this.amapAdapter.addMapControl('LB',35,65,25,30)
        });
    }


    public marker = null;
    public polyline = null;
    public polyline1 = null;
    public index = 0;

    public lineArr = [];

    public startIcon = 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/SLSUpload/20220902/327385257308229.png';
    public carIcon = 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/upload/1C2A9AA713942D3FC8F230378FF2D158.png';
    public endIcon = 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/SLSUpload/20220902/327385344864325.png';
    setPoint(arr, carCode) {
        // this.initMap();
        this.amapAdapter.resetPath();

        let that = this;
        if (!arr) {
            // this.$alert('没有定位记录');
            return;
        }
        this.lineArr = [];
        arr.forEach((item) => {
            this.lineArr.push(new AMap.LngLat(...bd09ToGcj02(item.longitude, item.latitude)));
        });
        // console.log('this.lineArr' + JSON.stringify(this.lineArr));
        this.lineArr.forEach((item, i) => {
           var content =
                            '<div>车牌号：' +
                            carCode +
                            '</div>' +
                            '<div>采集时间：' +
                            arr[i].locationTime +
                            '</div>' +
                            '<div>采集地址：' +
                            arr[i].address +
                            '</div>';

                        if (i == 0) {
                            if(item.lng>0&&item.lat>0){
                                this.amapAdapter.addMarker({ lnglat: item, icon: this.endIcon, content: content }, 41, 51,-20,-25)
                            }
                        } else if (i == this.lineArr.length - 1) {
                            if(item.lng>0&&item.lat>0){
                                this.amapAdapter.addMarker({ lnglat: item, icon: this.startIcon, content: content }, 48, 48,-24,-24)
                            }
                        } else {
                            this.amapAdapter.addMarker({ lnglat: item, icon: this.carIcon, content: content }, 41, 51,-20,-25)
                        }
                        // that.addClickHandler(content, this.marker, null);
        });

        // 1. 创建驾车路线规划实例（需确保AMap.Driving插件已加载）
        // var driving = new AMap.Driving({
        //     policy: 0, // 速度优先策略[1]
        //     map: this.amapAdapter.map,    // 自动将路线显示在地图上[5],
        //     hideMarkers: true, // 默认隐藏所有标记点
        //     overlayOptions: {
        //         hideOriginMarker: true,  // 隐藏起点图标
        //         hideDestinationMarker: true // 隐藏终点图标
        //     }
        // });

        // 4. 批量发起路径查询
        // let lineArrReverse = this.lineArr.reverse();
        // lineArrReverse.forEach((item, index) => {
          
        //     if (index < lineArrReverse.length - 1) {
        //         const start = [lineArrReverse[index].lng, lineArrReverse[index].lat];
        //         const end = [lineArrReverse[index + 1].lng, lineArrReverse[index + 1].lat];

        //         // 高德支持直接传入经纬度数组[1]
        //         driving.search(start, end, (status, result) => {
        //             // 每个查询单独处理结果
        //         });
        //     }
        // });
        // if (arr.length > 0) {
        //     this.amapAdapter.map.setZoomAndCenter(8,[arr[0].longitude, arr[0].latitude]);
        // }
    }

}
